import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { ReportService } from '../../../../../services/report.service';

@Component({
    selector: 'app-status-report-search',
    imports: [FormsModule, CommonModule,
        DropdownModule,
        CheckboxModule, ButtonModule, NextPage,
        CalendarModule,
    ],
    templateUrl: './status-report-search.component.html',
    styleUrl: './status-report-search.component.scss'
})
export class StatusReportSearchComponent implements OnInit {
  last7DaysChecked: boolean = true;
  includeDateRange: boolean = false;
  // services:string[] = [];
  // selectedRepairType!: string;
  // selectedDivision!: string;
  // repairTypes= ['ALL','Hot Trap'];
  // divisions = ['ALL','Division'];
  // last7DaysChecked: boolean = true;

  // dropDownOptions = [
  //   { label: 'ALL', value: 'All' },
  //   { label: 'Hot Trap', value: 'Hot Trap' }
  // ];
  filters = {
    dateRangeChecked: true,
    facility: '',
    startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
    endDate: new Date(),
    repairType: 'ALL',
    division: 'ALL',
    section: 'ALL',
    plant: 'ALL',
    associatedUnit: 'ALL',
    ldar: 'ALL',
    manageLeaksItems: 'ALL',
    materialStateItems: 'ALL',
    selctedServices: [],
    repairTypeDisplay: 'ALL',
    plantDisplay: 'ALL',
    serviceDisplay: 'ALL',
    ldarDisplay: 'ALL',
    divisionDisplay: 'ALL',
    sectionDisplay: 'ALL',
    manageLeaksItemsDisplay: 'ALL',
    materialStateItemsDisplay: 'ALL',
    associatedUnitDisplay: 'ALL',
  }
  divisions = [];
  repairTypes = [
  ];
  section = [];
  plant = [];
  associatedUnit = [];
  ldar = [];
  manageLeaksItems = [];
  materialStateItems = [];
  services: any = []

  @Output() generateReport: EventEmitter<any> = new EventEmitter<any>();
  pageType: string = '';
  showStartCalendar: boolean = false;
  reportTLRStatusPageLoadItems: any = {};
  @Input() searchPageTitle: string = '';
  @Input() showDateRange: boolean = true;

  constructor(private route: ActivatedRoute,
    private reportService: ReportService,
    private router: Router
  ) {
    this.filters.facility = this.reportService.getCurrentFacilityId();
  }
  ngOnInit() {
    this.route.params.subscribe(params => {
      this.pageType = params['type'];
    });

    this.reportService.getFilterListData().subscribe({
      next: (data: any) => {
        this.reportTLRStatusPageLoadItems = data;
        this.repairTypes = data.repairTypeItems;
        this.divisions = data.divisionItems;
        this.section = data.sectionItems;
        this.plant = data.plantItems;
        this.associatedUnit = data.associatedPlantItems;
        this.ldar = data.ldarItems;
        this.manageLeaksItems = data.manageLeaksItems;
        this.materialStateItems = data.materialStateItems;
        this.services = data.services.filter((item: any) => item.value !== 'ALL').map((item: any) => ({ label: item.name, value: item.value }));
        //this.services = data.Service.map((item: any) => ({ label: item, value: item }));


        //this.isLoading = false; // Set loading to false when data is loaded successfully
      },
      error: (error: any) => {
        console.error('Error fetching data:', error);
        //this.isLoading = false; // Set loading to false on error
      }
    });
  }
  runReport() {
    if (this.filters.dateRangeChecked) {
      this.filters.startDate = new Date(new Date(this.filters.endDate).getTime() - 7 * 24 * 60 * 60 * 1000);
    }
    this.generateReport.emit({ filters: this.filters, reportTLRStatusPageLoadItems: this.reportTLRStatusPageLoadItems });

  }
  toggleStartCalendar() {
    this.showStartCalendar = !this.showStartCalendar;
    if (this.showStartCalendar) {
      //this.showToCalendar = false; // Close the other calendar if open
    }
  }

  onDropDownChange(e: any, field: string) {
    if (field === 'repairType') {
      let tmp: any = this.repairTypes.find((each: any) => each.value === e.value);
      this.filters['repairTypeDisplay'] = tmp?.label;
    }
    if (field === 'division') {
      let tmp: any = this.divisions.find((each: any) => each.value === e.value);
      this.filters['divisionDisplay'] = tmp?.label;
    }
    if (field === 'section') {
      let tmp: any = this.section.find((each: any) => each.value === e.value);
      this.filters['sectionDisplay'] = tmp?.label;
    }
    if (field === 'plant') {
      let tmp: any = this.plant.find((each: any) => each.value === e.value);
      this.filters['plantDisplay'] = tmp?.label;
    }
    if (field === 'associatedUnit') {
      let tmp: any = this.associatedUnit.find((each: any) => each.value === e.value);
      this.filters['associatedUnitDisplay'] = tmp?.label;
    }
    if (field === 'ldar') {
      let tmp: any = this.ldar.find((each: any) => each.value === e.value);
      this.filters['ldarDisplay'] = tmp?.label;
    }
    if (field === 'manageLeaksItems') {
      let tmp: any = this.manageLeaksItems.find((each: any) => each.value === e.value);
      this.filters['manageLeaksItemsDisplay'] = tmp?.label;
    }
    if (field === 'materialStateItems') {
      let tmp: any = this.materialStateItems.find((each: any) => each.value === e.value);
      this.filters['materialStateItemsDisplay'] = tmp?.label;
    }

  }

}
